import React from 'react';
import Snowfall from 'react-snowfall';

const SnowfallEffect = () => {
  return (
    <div className="fixed inset-0 pointer-events-none z-10">
      <Snowfall
        color="#FFFFFF" // White snow only
        snowflakeCount={40}
        speed={[0.5, 1.5]}
        wind={[-0.2, 0.2]}
        radius={[0.5, 2.5]}
        style={{
          position: 'absolute',
          width: '100%',
          height: '100%',
        }}
      />
    </div>
  );
};

export default SnowfallEffect;